import { useCallback, useEffect, useState } from "react";

// Menu contextuel d'une ligne : ouvert au clic droit, fermé au prochain clic ou à la prochaine touche.
export function useCommandeContextMenu() {
    const [contextMenu, setContextMenu] = useState(null);

    const openContextMenu = useCallback((e, cmd) => {
        e.preventDefault();
        setContextMenu({ x: e.clientX, y: e.clientY, cmd });
    }, []);

    const closeContextMenu = useCallback(() => setContextMenu(null), []);

    useEffect(() => {
        if (!contextMenu) return;
        const close = () => setContextMenu(null);
        document.addEventListener("mousedown", close);
        document.addEventListener("keydown", close);
        return () => {
            document.removeEventListener("mousedown", close);
            document.removeEventListener("keydown", close);
        };
    }, [contextMenu]);

    return { contextMenu, openContextMenu, closeContextMenu };
}
